const toDateString = dateObj =>
  dateObj.toISOString();

export default toDateString;